"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var styles_1 = require("./styles");
function ToggleButtons(_a) {
    var options = _a.options, value = _a.value, setValue = _a.setValue, _b = _a.exclusive, exclusive = _b === void 0 ? false : _b, style = _a.style;
    function handleOptionButtonClick(option, event) {
        var newValue = option;
        if (!exclusive && typeof value !== "string") {
            newValue = __spreadArray(__spreadArray([], (value || []), true), [newValue], false);
        }
        setValue(newValue, event);
    }
    return (react_1.default.createElement(styles_1.MainContainer, { style: style && style.mainContainer }, options.map(function (option, index) {
        return (react_1.default.createElement(styles_1.ToggleButton, { key: index, isSelected: !!(value &&
                (typeof value === "string"
                    ? value === option.value
                    : value.find(function (selectedOption) { return selectedOption === option.value; }))), onClick: function (event) { return handleOptionButtonClick(option.value, event); }, customStyle: style && style.buttons }, option.label));
    })));
}
exports.default = ToggleButtons;
//# sourceMappingURL=index.js.map